var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2413 0C18.8627 0 21 1.99339 21 5.40566H16.5573V5.44048C14.4955 5.44048 12.824 6.99938 12.824 8.92239C12.824 10.8454 14.4955 12.4043 16.5573 12.4043H21V12.7177C21 16.0864 18.8627 18.0798 15.2413 18.0798H5.75867C2.13733 18.0798 0 16.0864 0 12.7177V5.36214C0 1.99339 2.13733 0 5.75867 0H15.2413ZM20.216 6.90288C20.649 6.90288 21 7.23025 21 7.63408V10.1759C20.995 10.5777 20.6469 10.9024 20.216 10.9071H16.6413C15.5975 10.9202 14.6848 10.2536 14.448 9.3054C14.3294 8.71677 14.4959 8.10936 14.9027 7.64597C15.3096 7.18257 15.9152 6.91058 16.5573 6.90288H20.216ZM17.0613 8.07802H16.716C16.504 8.0757 16.2998 8.15262 16.149 8.29164C15.9982 8.43065 15.9133 8.62018 15.9133 8.81793C15.9133 9.23281 16.2712 9.57048 16.716 9.57524H17.0613C17.5046 9.57524 17.864 9.24008 17.864 8.82664C17.864 8.41319 17.5046 8.07802 17.0613 8.07802ZM10.9013 3.90844H4.97467C4.53499 3.90841 4.17711 4.2383 4.172 4.64835C4.172 5.06322 4.52986 5.40089 4.97467 5.40566H10.9013C11.3446 5.40566 11.704 5.0705 11.704 4.65705C11.704 4.24361 11.3446 3.90844 10.9013 3.90844Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1688:9460",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 18.0798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.40afcb004e7b7279593ff09e743c2a1f.svg";
export { ForwardRef as ReactComponent };